
import { defineComponent, ref } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import useAuth from "@/auth/composables/useAuth";
export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    const { image } = useAuth();
    let imagen = ref("");
    if (image.value.length < 100) {
      imagen.value =
        "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png";
    } else {
      imagen.value = image.value;
    }
    return {
      imagen,
    };
  },
});
